import {
	WeaDialog
} from 'ecCom';
import {
	observer
} from 'mobx-react';

@observer
export default class Dialog extends React.Component {
	render() {
		const {
			store,
		} = this.props, {
			style,
			title,
			visible,
			buttons,
			staticDialogProps,
		} = store;

		return (
			<WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@s6se8f`}
				{...staticDialogProps}
				title={title}
				visible={visible}
				style={style}
				buttons={buttons}
			>
				{this.props.children}
			</WeaDialog>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/coms/Dialog.js